import apiFinance from '@/api/finance'

import {FINANCE_REFRESH_RATE} from '@/store/mutations'

const state = {
    rate: 0
}

const getters = {}

const mutations = {
    [FINANCE_REFRESH_RATE] (state, rate) {
        state.rate = rate
    }
}

const actions = {
    refreshRate ({ commit }) {
        apiFinance.loadRate(rate => {
            commit(FINANCE_REFRESH_RATE, rate)
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/finance.js